import moment from 'moment';
import numeral from 'numeral';
import _ from 'lodash';
import { string } from 'prop-types';

const unicodeMinus = '\u2212';

export const asBooleanString = (value: boolean) => (value ? 'Yes' : 'No');

export const asFormattedDate = (date: string) => {
	if (!date) return asTodaysDate();
	const parsed = moment(date, 'YYYYMMDD');
	return (parsed.isValid() && parsed.format('DD-MMM-YYYY')) || '';
};

export const asTodaysDate = () => {
	return moment()
		.local()
		.format('DD-MMM-YYYY');
};

export const asCurrency = (
	value: number | null,
	defaultValue: string | undefined = undefined
) => {
	return _.isNil(value)
		? typeof defaultValue === 'string'
			? defaultValue
			: toCurrency(0)
		: toCurrency(value);
};

const toCurrency = (value: number) =>
	numeral(value)
		.format('$0,0.00')
		.replace('-', unicodeMinus);

export const asNumber = (value?: number) => (value && value > 0 ? value : 0);

export const asPercentage = (
	value: number | null,
	decimal: boolean = true,
	defaultValue: string | undefined = undefined
) =>
	_.isNil(value)
		? defaultValue
		: numeral(value / 100).format(decimal ? '0.00%' : '0%', Math.round);

export const toCamelCase = (value: string) => _.camelCase(value);

export const padWithZeros = (value: number) => {
	if (!value) {
		return '';
	}

	// IE does not support padStart so we have to add our own implemenation here
	if (String.prototype.padStart) {
		return value.toString().padStart(9, '0');
	} else {
		let strValue = value.toString();
		const paddingLength = 9 - strValue.length;
		for (let i = 0; i < paddingLength; i++) {
			strValue = '0' + strValue;
		}
		return strValue;
	}
};

export const unicodeMinusToMinus = (value: string) =>
	value ? value.replace(unicodeMinus, '-') : value;
